import { removeLSCompanyIdx } from "./company";
import { removeLSToken } from "./token";

export function onLogout() {
  removeLSToken();
  removeLSCompanyIdx();
}